import { Button } from "@/components/ui/button";
import { CodeIcon, TrashIcon } from "lucide-react";

interface SnippetDisplayProps {
  promptName: string;
  version?: string;
  label?: string;
  isReadOnly?: boolean;
  onDelete?: () => void;
  href?: string;
  className?: string;
  onClick?: () => void;
}
const SnippetDisplay = ({
  promptName,
  version,
  label,
  isReadOnly,
  onDelete,
  href,
  className,
  onClick,
}: SnippetDisplayProps) => {
  const Wrapper = href ? "a" : "button";
  const wrapperProps = href
    ? { href, target: "_blank", rel: "noreferrer" }
    : { onClick };

  return (
    <Wrapper
      {...wrapperProps}
      className={`group/Snippet flex items-center justify-between rounded-full border border-gray-200 bg-gray-50/80 px-3 py-1.5 shadow-sm transition-all duration-150 ease-in-out hover:border-gray-300 hover:bg-white hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 active:bg-gray-100/90 ${
        className || ""
      }`}
    >
      <div className="flex items-center">
        <span className="mr-2.5 flex items-center justify-center rounded-full bg-gray-200/80 p-1.5 text-gray-500 shadow-sm transition-colors group-hover/Snippet:bg-gray-300/90 group-hover/Snippet:text-gray-600">
          <CodeIcon className="h-3.5 w-3.5" />
        </span>
        <span className="font-mono text-sm font-semibold text-gray-700 transition-colors group-hover/Snippet:text-gray-900">
          {promptName ||
            (isReadOnly ? "No snippet selected" : "Select snippet")}
        </span>
      </div>
      <div className="ml-3 flex items-center space-x-2">
        {label && (
          <span
            className={`rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-600 shadow-sm transition-colors ${
              href ? "hover:bg-blue-100" : ""
            }`}
          >
            {label}
          </span>
        )}
        {!label && (
          <span
            className={`rounded-full bg-gray-100/90 px-2.5 py-1 text-xs font-medium text-gray-600 shadow-sm transition-all ${
              href
                ? "group-hover/Snippet:bg-gray-200/90 group-hover/Snippet:text-gray-700"
                : "duration-150 ease-in-out group-hover:bg-gray-200/90 group-hover:text-gray-700"
            }`}
          >
            {version ? `v${version}` : "Default"}
          </span>
        )}
        {!isReadOnly && onDelete && (
          <Button
            variant="destructiveLink"
            size="tinyIcon"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <TrashIcon className="h-3.5 w-3.5" />
          </Button>
        )}
      </div>
    </Wrapper>
  );
};

export default SnippetDisplay;
